import React, { useContext } from 'react';
import { BackgroundImage, Background, Content } from './components';
import Image from '../Image';

import { StyleSheetManager, StylisPlugin } from 'styled-components';
import DirectionContext from '../../../configuration/context/direction';
import stylisRTLPlugin from 'stylis-plugin-rtl';

export type DisablePaddingsType = {
  before?: boolean;
  after?: boolean;
  start?: boolean;
  end?: boolean;
};
type ContainerPropTypes = React.PropsWithChildren<{
  id?: string;
  background?: {
    color?: string;
    images?: React.ComponentProps<typeof Image>['sources'];
  };
  color?: string;
  accentColor?: string;
  textAlign?: React.CSSProperties['textAlign'];
  disablePaddings?: DisablePaddingsType;
  disableMaxWidth?: boolean;
  direction?: string;
}> &
  Omit<React.ComponentProps<typeof Background>, 'background'>;

const Wrapper = ({
  id,
  containerBackground,
  props,
  children: WrapperChildren,
}: {
  id: ContainerPropTypes['id'];
  containerBackground: ContainerPropTypes['background'];
  props: Omit<ContainerPropTypes, 'background'>;
  children: React.ReactNode;
}) => {
  return containerBackground?.images ? (
    <BackgroundImage
      forwardedAs="section"
      sources={containerBackground.images}
      background={containerBackground?.color}
      id={id}
      {...props}
    >
      {WrapperChildren}
    </BackgroundImage>
  ) : (
    <Background id={id} background={containerBackground?.color} {...props}>
      {WrapperChildren}
    </Background>
  );
};

function Container({
  color,
  accentColor,
  id,
  textAlign,
  disablePaddings,
  disableMaxWidth,
  children,
  background,
  ...props
}: ContainerPropTypes) {
  const direction = useContext(DirectionContext);

  const plugins: StylisPlugin[] = [];

  if (direction === 'rtl') {
    plugins.push(stylisRTLPlugin);
  }
  return (
    <StyleSheetManager stylisPlugins={plugins}>
      <Wrapper id={id} containerBackground={background} props={props}>
        <Content
          color={color}
          accentColor={accentColor}
          textAlign={textAlign}
          disablePaddings={disablePaddings}
          disableMaxWidth={disableMaxWidth}
        >
          {children}
        </Content>
      </Wrapper>
    </StyleSheetManager>
  );
}

export default Container;
